export default __webpack_public_path__ + "static/players-d694eeb6580a9f39988da61166181aa7.png";